module.exports = __webpack_public_path__ + "static/media/loan.5d83ce91.png";